/**
 * Splits cart recommendation titles into flavor, product line and size.
 *
 * The Caffeine recommendations embed renders one long title per card. This
 * applies the rule from snippets/cart-title-parts.liquid to those cards: a
 * segment that starts with a number is the size, one that names the shop is
 * the product line, and the rest is the flavor. Titles without " - " stay as
 * they are. It only changes presentation; links, prices and adds are untouched.
 */
(function (global) {
  "use strict";
  if (global.CaffeineCartTitles && typeof module === "undefined") return;

  var SIZE = /^\d+(?:\.\d+)?(?:\s+\S+){0,2}$/;

  function splitTitle(title, brand) {
    var text = String(title || "").trim();
    var segments = text.split(" - ").map(function (part) { return part.trim(); }).filter(Boolean);
    if (segments.length < 2) return null;

    var needle = String(brand || "").trim().toLowerCase();
    var flavor = [];
    var line = "";
    var size = "";

    segments.forEach(function (part) {
      if (!size && SIZE.test(part)) size = part;
      else if (!line && needle && part.toLowerCase().indexOf(needle) !== -1) line = part;
      else flavor.push(part);
    });

    if (!flavor.length) {
      if (!line) return null;
      flavor.push(line);
      line = "";
    }
    // "Wellious Protein Powder" reads as "Wellious Protein" so the product line fits on one line.
    line = line.replace(/\s+powder$/i, "");
    return { flavor: flavor.join(" - "), line: line, size: size };
  }

  function span(doc, className, text) {
    var el = doc.createElement("span");
    el.className = className;
    el.textContent = text;
    return el;
  }

  function isSplit(el) {
    var first = el.firstElementChild || (el.children && el.children[0]);
    return !!first && /(^|\s)cart-title(\s|$)/.test(first.className);
  }

  // Replaces el's text with the split markup. Returns the parts, or null when
  // el is already split or its title has no parts to show.
  function splitInto(el, brand) {
    if (!el || isSplit(el)) return null;
    var parts = splitTitle(el.textContent, brand);
    if (!parts) return null;

    var doc = el.ownerDocument;
    var wrap = span(doc, "cart-title", "");
    wrap.appendChild(span(doc, "cart-title__flavor", parts.flavor));
    if (parts.line || parts.size) {
      var meta = span(doc, "cart-title__meta", "");
      if (parts.line) meta.appendChild(span(doc, "cart-title__line", parts.line));
      if (parts.size) meta.appendChild(span(doc, "cart-title__size", parts.size));
      wrap.appendChild(meta);
    }
    el.replaceChildren(wrap);
    return parts;
  }

  function splitCard(card, brand) {
    var parts = splitInto(card.querySelector(".caffeine-recommendations__title"), brand);
    if (!parts || !parts.size) return;
    var variant = card.querySelector(".caffeine-recommendations__variant");
    if (variant && variant.textContent.trim().toLowerCase() === parts.size.toLowerCase()) {
      variant.hidden = true;
    }
  }

  // The flavor a title names, lowercased, for matching across sizes.
  function flavorKey(title, brand) {
    var parts = splitTitle(title, brand);
    return String(parts ? parts.flavor : title || "").trim().toLowerCase();
  }

  function flavorsInCart(scope) {
    var flavors = {};
    scope.querySelectorAll("[data-line-item-key] [data-product-title]").forEach(function (node) {
      var flavor = node.querySelector(".cart-title__flavor");
      var key = String((flavor || node).textContent || "").trim().toLowerCase();
      if (key) flavors[key] = true;
    });
    return flavors;
  }

  // Recommendations skip flavors already in the cart, whatever their size, and
  // show each remaining flavor once (the first card, in the campaign's order).
  function splitMount(mount) {
    var brand = mount.getAttribute("data-title-brand") || "";
    var scope = mount.closest("[data-cart-items]") || mount.ownerDocument;
    var taken = flavorsInCart(scope);
    var cards = mount.querySelectorAll(".caffeine-recommendations__card");
    var shown = 0;
    cards.forEach(function (card) {
      var title = card.querySelector(".caffeine-recommendations__title");
      var raw = title ? title.getAttribute("data-raw-title") || title.textContent : "";
      if (title && !title.hasAttribute("data-raw-title")) title.setAttribute("data-raw-title", raw);
      splitCard(card, brand);
      var key = flavorKey(raw, brand);
      card.hidden = !!taken[key];
      if (!card.hidden) {
        taken[key] = true;
        shown += 1;
      }
    });
    mount.toggleAttribute("data-cart-flavors-covered", cards.length > 0 && shown === 0);
  }

  function start(doc) {
    var selector = '[data-caffeine-recommendations][data-placement="cart_drawer"]';
    var queued = false;

    function run() {
      queued = false;
      doc.querySelectorAll(selector).forEach(splitMount);
      // Product pages keep every card (a bigger size of the same flavor is a fair upsell there); titles still split.
      doc.querySelectorAll('[data-caffeine-recommendations][data-placement="pdp"]').forEach(function (mount) {
        var brand = mount.getAttribute("data-title-brand") || "";
        mount.querySelectorAll(".caffeine-recommendations__card").forEach(function (card) { splitCard(card, brand); });
      });
    }

    run();
    if (typeof global.MutationObserver !== "function") return;
    new global.MutationObserver(function () {
      if (queued) return;
      queued = true;
      // Animation frames pause in hidden tabs; a timer keeps a backgrounded page current.
      var later = global.document && global.document.hidden ? global.setTimeout : (global.requestAnimationFrame || global.setTimeout);
      later(run);
    }).observe(doc.body, { childList: true, subtree: true });
  }

  var api = { splitTitle: splitTitle, splitInto: splitInto, splitCard: splitCard, flavorKey: flavorKey };
  if (typeof module === "object" && module.exports) {
    module.exports = api;
    return;
  }
  global.CaffeineCartTitles = api;
  if (global.document) {
    if (global.document.readyState === "loading") {
      global.document.addEventListener("DOMContentLoaded", function () { start(global.document); }, { once: true });
    } else {
      start(global.document);
    }
  }
})(typeof window !== "undefined" ? window : globalThis);
